function Chat ()
{
    const script=document.createElement('script');
      script.src='//js.hs-scripts.com/8509720.js';
      script.async=true;
      
    return (
        <>
        {document.body.append(script)}
        </>
        
    )
}

export default Chat